import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { DifferenceSection } from './components/DifferenceSection';
import { AudienceSection } from './components/AudienceSection';
import { AuthorStory } from './components/AuthorStory';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCTA } from './components/PricingCTA';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-warm-bg font-sans text-warm-dark selection:bg-sage/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ContentSection data-id="element-4" />
      <DifferenceSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <AuthorStory data-id="element-7" />
      <BenefitsSection data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FAQSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}